//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect, useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  IconButton,
} from '@mui/material';
import { Delete, DragHandle } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer            } from 'components/Spacer.jsx';
import { ExpressionContext } from '../Context/ExpressionContext.jsx';
import { FieldControls     } from './components/Field/FieldControls.jsx';
import { OperatorControls  } from './components/Operator/OperatorControls.jsx';
import { RecordControls    } from './components/Record/RecordControls.jsx';
import { ConstantControls  } from './components/Constant/ConstantControls.jsx';
import { SourceSelect      } from './components/SourceSelect/SourceSelect.jsx';
import { FunctionControls  } from './components/Function/FunctionControls.jsx';


//#endregion

//-----------------------------------------------------------------
export function Expression( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { id, data } = props.data;

  const expression = useContext( ExpressionContext );

  const [ source, setSource ] = useState(data?.source);

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    container: {
      height: '100%',
      width: '100%',
      boxShadow: 0,
      paddingTop: '1rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
    },
    border_1: {
      display: 'flex',
      // border: 'solid 2px ' + theme.palette.primary[theme.palette.mode],
      // boxShadow: '2px 2px 8px ' + theme.palette.primary[theme.palette.mode],
      borderRadius: '1rem',
      padding: '1rem',
      marginLeft: '0.5rem',
      width: 'max-content',
      backgroundColor: theme.palette.background.primary[theme.palette.mode]
    },
    border_2: {
      // display: 'flex',
      border: 'solid ' + theme.palette.primary[theme.palette.mode],
      borderRadius: '1rem',
      padding: '1rem',
      width: 'max-content',
    },
    button_add: {
      backgroundColor: theme.palette.primary[theme.palette.mode],
      color: 'white'
    },
    button_remove: {
      width  : '3rem',
      height : '3rem',
    },
    icon: {
      'color' : 'green',
      'transform': 'rotate( 90deg )',
    },
  }

  const BORDER_1 = {
    style: _styles.border_1,
  };
  const BUTTON_DELETE = {
    sx: _styles.button_remove,
    // variant: 'contained',
    onClick: () => expression.removeExpression(id),
    children: <Delete />,
  };
  const BUTTON_DRAG = {
    sx: _styles.button_remove,
    // variant: 'contained',
    children: <DragHandle />,
  };
  const ICON = {
    sx       : _styles.icon,
    fontSize : 'large',
  }
    
  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    setSource( data?.source )
  }, [data])

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange_Source( value ) {
    //-----------------------------------------------------------------
    setSource( value )
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div style={{ display: 'flex', alignItems: 'center' }} >
        <div { ...BORDER_1 } >
          {/* <IconButton { ...BUTTON_DRAG      } /> */}
          <IconButton { ...BUTTON_DELETE    } />
          <Spacer />
          <SourceSelect id={id} source={data?.source} onChange={onChange_Source} />
          <Spacer />
          { displayComponents() }
        </div>
        <Spacer width='2rem' />
      </div>
    );
  }

  //-----------------------------------------------------------------
  function displayComponents() {
    //-----------------------------------------------------------------
    if( source === 'FIELD' ) {
      return <FieldControls id={id} data={data} />
    }

    if( source === 'DOR' ) {
      return <RecordControls id={id} data={data} />;
    }

    if( source === 'OPERATOR' ) {
      return <OperatorControls id={id} data={data} />;
    }

    if( source === 'CONSTANT' ) {
      return <ConstantControls id={id} data={data} />;
    }

    if( source === 'FUNCTION' ) {
      return <FunctionControls id={id} data={data} />;
    }

  }

  //#endregion

  return display();
}
